export const PRODS = ["Trafalgar SFP", "TRF Casa de Bolsa", "Seguros"];
export const LINEAS = ["Captación a plazo", "Crédito PYME"];
export const DECL = {
  d1: "La información y los documentos que proporciono son verdaderos y están vigentes.",
  d2: "No he sido condenado por delitos patrimoniales, fiscales ni de operaciones con recursos de procedencia ilícita.",
  d3: "No recibiré efectivo ni recursos de los clientes; toda operación se realiza directamente con Trafalgar.",
  d4: "Entiendo que no soy empleado ni mandatario de Trafalgar y que no puedo prometer rendimientos ni aprobaciones.",
};

// Una pregunta por pantalla; «rep» solo PM y «lineas» solo si eligió Trafalgar SFP.
export const pasos = (r) => ["welcome", "tipo", "nombre", "rfc", ...(r.tipo === "PM" ? ["rep"] : []), "email", "celular", "dom", "clabe", "prod",
  ...((r.prod || []).includes("Trafalgar SFP") ? ["lineas"] : []), "perfil", "clientes", "pep", "decl", "docs", "conv", "acepta", "done"];

const RFC = { PF: /^[A-ZÑ&]{4}\d{6}[A-Z0-9]{3}$/, PM: /^[A-ZÑ&]{3}\d{6}[A-Z0-9]{3}$/ };
export const clabeOk = (c) => /^\d{18}$/.test(c) && (10 - ([...c.slice(0, 17)].reduce((s, d, i) => s + ((+d * [3, 7, 1][i % 3]) % 10), 0) % 10)) % 10 === +c[17];
const t = (v) => (v || "").trim();

// Mismas reglas que el servidor; devuelve el mensaje de error o "".
export const error = (k, r) => ({
  tipo: !r.tipo && "Elige persona física o moral.",
  nombre: t(r.nombre).length <= 3 && "Escribe el nombre completo o razón social.",
  rfc: !RFC[r.tipo || "PF"].test(t(r.rfc).toUpperCase()) && (r.tipo === "PM" ? "RFC inválido: persona moral 12 caracteres (AAA000000XXX)." : "RFC inválido: persona física 13 caracteres (AAAA000000XXX)."),
  rep: t(r.rep).length <= 3 && "Escribe el nombre del representante legal.",
  email: !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(t(r.email)) && "Correo electrónico inválido.",
  celular: (r.celular || "").replace(/\D/g, "").length !== 10 && "Escribe 10 dígitos.",
  dom: t(r.dom).length <= 10 && "Escribe el domicilio completo.",
  clabe: !clabeOk((r.clabe || "").replace(/\D/g, "")) && "CLABE inválida: 18 dígitos con dígito verificador correcto.",
  prod: !(r.prod || []).length && "Elige al menos un producto.",
  lineas: !(r.lineas || []).length && "Elige al menos una línea de Trafalgar SFP.",
  perfil: !(t(r.actividad).length > 1 && t(r.zona).length > 1) && "Indica tu actividad y tu zona.",
  clientes: !r.clientes && "Elige una opción.",
  pep: !(r.pep === "no" || (r.pep === "si" && t(r.pep_detalle).length > 3)) && (r.pep === "si" ? "Describe cargo, institución y periodo." : "Responde si eres PEP."),
  decl: !["d1", "d2", "d3", "d4"].every((d) => r[d] === true) && "Confirma las cuatro declaraciones.",
  conv: r.acepta_conv !== true && "Marca «Leí y acepto el convenio, sus anexos y las declaraciones».",
  rep_cargo: t(r.rep_cargo).length <= 1 && "Escribe el cargo del representante legal.",
}[k] || "");

// Paso 1 «Tus datos»: primer error de sus campos.
export const CAMPOS_DATOS = (r) => ["tipo", "nombre", "rfc", ...(r.tipo === "PM" ? ["rep", "rep_cargo"] : []), "email", "celular"];
export const errorDatos = (r) => CAMPOS_DATOS(r).map((k) => error(k, r)).find(Boolean) || "";

export const valido = (k, r) => !error(k, r);
